import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className={styles.footer}>
      <div className={styles.footerCrest}>
        <span className={styles.crownSymbol}>♔</span>
      </div>
      
      <div className={styles.footerTop}>
        <div className={styles.footerSection}>
          <h3 className={styles.footerLogo}>
            <span className={styles.highlight}>THRONE</span> STONE
          </h3>
          <p className={styles.footerTagline}>
            Crafting timeless stone structures since 1892
          </p>
          <div className={styles.contact}>
            <p><i className={styles.icon}>📍</i> No. 429/4, Ganemulla Road, Kadawatha</p>
            <p><i className={styles.icon}>📞</i> +94 0767934836</p>
            <p><i className={styles.icon}>✉️</i> chamarathronestone@yahoo.com</p>
          </div>
        </div>
        
        
        <div className={styles.footerSection}>
          <h4>Company</h4>
          <ul className={styles.footerLinks}>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/gallery">Distinguished Portfolio</Link></li>
            <li><Link to="/stones">Stone Varities</Link></li>
            <li><Link to="/about">Our Heritage</Link></li>
            <li><Link to="/about">Request Consultation</Link></li>
          </ul>
        </div>
        
        <div className={`${styles.footerSection} ${styles.newsletterSection}`}>
          <h4>Correspondence</h4>
          <p>Subscribe to receive updates on our latest commissions and materials</p>
          <form className={styles.newsletterForm}>
            <input 
              type="email" 
              placeholder="Your email address" 
              required 
              className={styles.newsletterInput} 
            />
            <button type="submit" className={styles.newsletterButton}>
              Subscribe
            </button>
          </form>
          <div className={styles.socialLinks}>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className={styles.socialIcon}>f</i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className={styles.socialIcon}>i</i>
            </a>
          </div>
        </div>
      </div>
      
      <div className={styles.footerDivider}></div>
      
      <div className={styles.footerBottom}>
        <div className={styles.copyright}>
          &copy; {currentYear} Throne Stone. All rights reserved.
        </div>
        <div className={styles.footerBottomLinks}>
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;